import React from 'react';
import CTAButton from '../../components/CTAButton';
import './Technology.css';

const Technology = () => {
  const technologyCategories = [
    {
      id: 'ai-ml',
      title: 'AI & Machine Learning Stack',
      description: 'Our AI and machine learning solutions are built using powerful, industry-standard languages known for their extensive libraries and robust performance in data science and predictive analytics.',
      technologies: [
        { name: 'Python', logo: '🐍' },
        { name: 'JAVA', logo: '☕' }
      ]
    },
    {
      id: 'cloud-devops',
      title: 'Cloud & DevOps Toolkit',
      description: 'We build scalable, resilient, and secure applications using leading cloud platforms and modern DevOps practices. Our expertise in CI/CD ensures efficient and reliable deployment.',
      technologies: [
        { name: 'AWS', logo: '☁️' },
        { name: 'Azure', logo: '🔷' },
        { name: 'Google Cloud', logo: '🌐' },
        { name: 'Docker', logo: '🐳' },
        { name: 'GitLab', logo: '🦊' }
      ]
    },
    {
      id: 'frontend',
      title: 'Application & Frontend Layer',
      description: 'We create intuitive and responsive user experiences using modern frameworks for web, mobile, and eCommerce. Our full-stack expertise ensures seamless integration between the user interface and backend logic.',
      technologies: [
        { name: 'JavaScript', logo: '📜' },
        { name: 'TypeScript', logo: '🔷' },
        { name: 'React', logo: '⚛️' },
        { name: 'React Native', logo: '📱' },
        { name: 'Node.js', logo: '🟢' },
        { name: 'Redux', logo: '🔄' },
        { name: 'PHP', logo: '🐘' },
        { name: 'Shopify', logo: '🛍️' },
        { name: 'WordPress', logo: '📝' },
        { name: 'Bootstrap', logo: '🎨' }
      ]
    },
    {
      id: 'databases',
      title: 'Database & Data Management',
      description: 'Data is the core of any intelligent application. We are proficient with a wide range of SQL and NoSQL databases, allowing us to choose the perfect solution for your data storage, retrieval, and management needs.',
      technologies: [
        { name: 'PostgreSQL', logo: '🐘' },
        { name: 'MySQL', logo: '🐬' },
        { name: 'MongoDB', logo: '🍃' },
        { name: 'Oracle', logo: '🗿' },
        { name: 'Firebase', logo: '🔥' },
        { name: 'SQLite', logo: '💎' }
      ]
    }
  ];

  return (
    <main>
      {/* Page Header Section */}
      <section className="page-header">
        <div className="page-header-bg">
          <div className="tech-stack-bg"></div>
        </div>
        <div className="page-header-content">
          <h1 className="page-header-title">Our Technology Stack</h1>
          <p className="page-header-subtitle">
            We use a curated set of modern, powerful, and scalable technologies to build robust solutions.
          </p>
        </div>
      </section>

      {/* Technology Showcase Section */}
      <section className="technology-showcase">
        <div className="container">
          {technologyCategories.map((category) => (
            <div key={category.id} className="technology-category">
              <div className="category-header">
                <h2 className="category-title">{category.title}</h2>
                <p className="category-description">{category.description}</p>
              </div>
              
              <div className="technology-grid">
                {category.technologies.map((tech, index) => (
                  <div key={index} className="technology-item">
                    <div className="tech-logo">
                      <span className="tech-emoji">{tech.logo}</span>
                    </div>
                    <span className="tech-name">{tech.name}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Technical Requirements CTA Section */}
      <section className="tech-requirements-cta">
        <div className="container">
          <h2 className="cta-headline">Have a specific technology requirement?</h2>
          <p className="cta-subtext">
            Our team is adaptable and always ready to work with the technologies that best suit your project's needs. Let's discuss your technical architecture.
          </p>
          <CTAButton variant="primary" size="large" href="/contact">Talk to an Engineer</CTAButton>
        </div>
      </section>
    </main>
  );
};

export default Technology;
